import { FORMIK_EMPTY_VALUE } from '../../../../constants/validation'

export const RECOVER_PASSWORD_FORM_SERVER_ERROR_USER_IS_NOT_ACTIVE =
  'UserIsNotActive'

export const RECOVER_PASSWORD_FORM_SERVER_ERROR_NOT_VALID_EMAIL =
  'email_required'

export const RECOVER_PASSWORD_FORM_SERVER_NON_FIELD_ERRORS = {
  [RECOVER_PASSWORD_FORM_SERVER_ERROR_NOT_VALID_EMAIL]:
    'Error.AuthRecoverPasswordFormEmailIsInvalid',
  [RECOVER_PASSWORD_FORM_SERVER_ERROR_USER_IS_NOT_ACTIVE]:
    'Error.AuthRecoverPasswordFormUserIsNotActive',
}

export const RECOVER_PASSWORD_FORM_NOTIFICATION_ERROR_ID = 'error'

export const RECOVER_PASSWORD_FORM_FIELD_HEIGHT = 48

export const RECOVER_PASSWORD_FORM_FIELD_NAME_EMAIL = 'email'

export const RECOVER_PASSWORD_FORM_EMAIL_MAX_LENGTH = 128

export const RECOVER_PASSWORD_FORM_INITIAL_VALUES = {
  [RECOVER_PASSWORD_FORM_FIELD_NAME_EMAIL]: FORMIK_EMPTY_VALUE,
}
